import React from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons'
import { Calendar } from 'react-calendar';
import { DatePicker } from 'antd'
import SearchFilter from '../../../components/filters/SearchFilter';
// import Main from '../../Pages/Demo/main';
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import services from '../../../services';
var moment = require('moment')
const dateFormat = "YYYY-MM-DD";
const { RangePicker } = DatePicker

/*
Formato de solicitação padrão para todas as APIs de listagem   
*/
const listdefaultRequest = { "Filters": null, "SortBy": "", "IsSortTypeDESC": false, "IsPagination": false, "Page": 1, "PageSize": 100 }


const tabDetailArray = {
    'Conta corrente': {
        api: '/Vindima/PaymentNotSent/GetAll',
        columnkeyMap: {
            "nº doc": "#",
            "data": "data",
            "document_url": "referência",
            "disription": "descrição",
            "qnt": "qnt",
            "unit": "un",
            "valor": "valor",
            "iva": "iva"
        },
        actionbuttons: { Edit: false, Redirect: false, Delete: false }
    }
}


class RevenueSecondModalForm extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            listData: [],
            popUpDetail: {},
            filterData: {},
            telkikTable: "",
            propRow: {},
            tipoList: [],
            commonTotalDetails: []
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.popupTabTable('');
        this.getTotalDetails();

    }
    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (this.props.date !== preProp.date) {
            this.popupTabTable('');
            this.getTotalDetails();

        }
    }

    /*  Para carregar a tabela em um pop-up */

    popupTabTable = (tabName) => {
        let tabData = tabDetailArray[this.props.tab]
        this.setState({
            telkikTable: "",
            popUpDetail: tabData
        })
    }

    /* Atualizar dados de API para formatos de hospedagem de página */
    getTotalDetails = () => {

        let issueDocumentDetails = this.props.completeData.issueDocumentDetails;
        let allTransaction = this.props.completeData.allTransaction;
        let RequiredDetails = {
            "nº doc": "",
            "data": null,
            "document_url": "",
            "disription": "",
            "Valor total": 0,
            "qnt": 0,
            "unit": 0,
            "valor": 0,
            "iva": 0,
            "Quantity_total": 0
        };

        allTransaction.map((r, i) => {
            RequiredDetails["nº doc"] = this.props.row.id;
            RequiredDetails["data"] = moment(this.props.row.deadline_date).format(dateFormat);
            RequiredDetails["document_url"] = this.props.row.document_url;
            RequiredDetails["disription"] = this.props.row.document_type;
            RequiredDetails["iva"] = this.render.vat_rate;

            if (r.trans_type === "CR") {
                RequiredDetails[r.trans_method] = RequiredDetails[r.trans_method] ? RequiredDetails[r.trans_method] + parseFloat(r.total_cr) : parseFloat(r.total_cr);
                RequiredDetails["Valor total"] += parseFloat(r.total_cr);
            } else {
                RequiredDetails["Valor total"] += parseFloat(r.total_dr)
            }
            if (r.transactionDetail) {
                r.transactionDetail.map((row, k) => {
                    RequiredDetails["qnt"] += row.quantity;
                    RequiredDetails["unit"] += row.unit_amount;
                })
            }
        });
        let columnkeyMap = tabDetailArray[this.props.tab].columnkeyMap;
        console.log("columnkeyMap", columnkeyMap);
        let res = [];
        res.push(RequiredDetails);
        console.log("res", res);

        res.map((_row, index) => {
            Object.keys(columnkeyMap).map(function (key) {
                _row[columnkeyMap[key]] = _row[key]
            })
        });
        this.setState({
            commonTotalDetails: res,
            data: res,
            filterData: res,
            totalcount: res.length
        }, () => this.createTabel());
    }


    
    /*   Para executar a API de um pop-up para obter dados */
    getPopUpListData = async () => {
        console.log("PORPS and POPUPDETAIL", this.props, this.state.popUpDetail)
        if (this.state.popUpDetail && listdefaultRequest) {
            let Request = listdefaultRequest;
            let link = this.state.popUpDetail.api;
            let res = await services.apiCall.requestApi(link, Request, 'post')
            if (res) {
                if (this.state.popUpDetail.columnkeyMap) {
                    let columnkeyMap = this.state.popUpDetail.columnkeyMap;
                    res.map((_row, index) => (
                        Object.keys(columnkeyMap).map(function (key) {
                            _row[columnkeyMap[key]] = _row[key]
                        })
                    ));
                    this.setState({
                        data: res,
                        filterData: res,
                        totalcount: window.localStorage.getItem('table_total')
                    }, () => this.createTabel())
                }
            }
        }
    }

    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {
        this.setState({
            filterData: data
        }, () => this.createTabel())
    }

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        let actionbuttons = this.state.popUpDetail.actionbuttons;
        let columnkeyMap = this.state.popUpDetail.columnkeyMap;
        let columnlist = Object.keys(columnkeyMap).map(function (key) {
            return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
        });
        let data = this.state.filterData;
        let telkikTable = <TlkTable
            date={new Date()}
            groupfield={this.state.popUpDetail.groupfield}
            notAction={true}
            list={data}
            actionbuttons={actionbuttons}
            columnlist={columnlist}
            ActionPerform={(action, id) => this.ActionPerform(action, id)}
        />
        this.setState({
            telkikTable: telkikTable
        })
    }


    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (action === 'Redirect') {
            if (this.props.tab === 'Conta corrente faturasRecibos' || this.props.tab === 'Conta corrente faturas') {

            }
        }
    }


    /*   Classificar dados de acordo com o ano */

    sortData = (list) => {
        let sortListData = list.sort(
            function (a, b) {
                if (a.year < b.year)
                    return 1;
                else
                    return -1;
            }
        )

        return sortListData
    }

    /*  handel dados ao salvar */

    handleSubmitData = (data) => {
        console.log("DATAPROPS", data)
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        console.log("row", this.props.row)
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className="modal-title pl-0">Informação detalhada do documento</h4>
                    <ul className="navbar-nav custom-menu float-right mr-2 user-alert-head">
                        <li className="nav-item dropdown">
                            {/* <span className="nav-link d-flex justify-content-between" id="navbardrop" data-toggle="dropdown">
                            <span className="remoove mr-2">imprimir</span>
                        </span>  */
                            }
                            <div className="dropdown-menu user-alert">
                                <span className="dropdown-item cursor-pointer">
                                    <span className="content">
                                        <p> nº cópias guia <input type="number" id="numberofcopies" /></p>
                                        <p> <input type="checkbox" checked={true} /> Pré-visualizar</p>
                                    </span>
                                </span>
                                {/* <span className="dropdown-item">
                              <span className="content">
                                 <p>imprimir</p>
                              </span>
                           </span>  */
                                }
                            </div>

                        </li>

                    </ul>



                    <span onClick={() => this.props.closePopup()} className="remoove cursor-pointer mr-2">fechar</span>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-6">
                            <p><strong>Nº Entidade</strong></p>
                            <p>{this.props.completeData.busEntidade.nifap}</p>
                        </div>
                        <div className="col-md-6">
                            <p><strong>entidade</strong></p>
                            <p>{this.props.completeData.busEntidade.nome}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <p><strong>Data doc.</strong></p>
                            <p>{moment(this.props.row.deadline_date).format(dateFormat)}</p>
                        </div>
                        <div className="col-md-6">
                            <p><strong>Nº doc.</strong></p>
                            <p>{this.props.row['nº doc']}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <p><strong>Valor total</strong></p>
                            <p>{this.props.row['Valor (c/ iva)']}</p>
                        </div>
                        <div className="col-md-4">
                            <p><strong>IVA</strong></p>
                            <p>{this.props.row['iva']}</p>
                        </div>
                        <div className="col-md-4">
                            <p><strong>Qtd. total</strong></p>
                            {
                                this.state.commonTotalDetails[0] &&
                                <p>{this.state.commonTotalDetails[0]['Quantity_total']}</p>
                            }

                        </div>
                    </div>
                    <div style={{ marginTop: "20px" }} >
                        {
                            this.state.telkikTable
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default RevenueSecondModalForm;